// Libraries
var React = require('react');
var Entities = require('html-entities').AllHtmlEntities;

// Styles
require('./CommentaryComment.scss');

// Assets
var iconScore = require('MDC/Timeline/svgs/football_spurs.svg');
var iconYellowCard = require('images/yellow_card.svg');
var iconRedCard = require('images/red_card.svg');
var iconSubstitution = require('images/subs_spurs.svg');

// Components
var Slide = require('Highlights/Slide');
var LocalTimeConverter = require('LocalTimeConverter/LocalTimeConverter');

class CommentaryComment extends React.Component {

	decodeComment(comment) {

		let entities = new Entities();
		let commentDecoded = entities.decode(comment);
		const reg = /(http)?[a-zA-Z0-9\-/:.]*(Image\/)/g;
		commentDecoded = commentDecoded.replace(reg, this.props.baseUrl + "Image/");
		return commentDecoded;
	}

	createTime(timestamp) {

		var date = LocalTimeConverter(timestamp);

		let hours = date.getHours();
		let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

		return hours + ":" + minutes;
	}

	componentDidMount() {
		// Load the url's for scripts appended in the scripts.
		// i.e.: Twitter Cards.
		let urls = this.decodeComment(this.props.comment.Comment).match(/<script.*?src="(.*?)"/g);

		if (urls !== null) {
			urls.map((el) => {
				let scriptTag = document.createElement('script');
				scriptTag.src = el.match(/<script.*?src="(.*?)"/)[1];
				document.getElementsByTagName('body')[0].appendChild(scriptTag);
				return true;
			});
		}
	}

	render() {
		const getEventIcon = (eventType) => {
			switch (eventType) {
				case "Goal":
					return <img className="CommentaryComment__icon" src={iconScore} alt="Score"/>;
				case "YellowCard":
					return <img className="CommentaryComment__icon" src={iconYellowCard} alt="Yellow Card"/>;
				case "RedCard":
					return <img className="CommentaryComment__icon" src={iconRedCard} alt="Red Card"/>;
				case "Substitution":
					return <img className="CommentaryComment__icon" src={iconSubstitution} alt="Substitution"/>;
				default:
					return <span/>;
			}
		};

		const getSeparator = (comment) => {
			switch (comment.EventType) {
				case "Goal":
					return <div className="CommentaryComment__separator--blue" />;
				case "PenaltyShot":
					if (comment.Outcome === "Scored") {
						return <div className="CommentaryComment__separator--blue" />;
					} else {
						return <div className="CommentaryComment__separator--gray" />;
					}
				case "YellowCard":
				case "RedCard":
				case "Substitution":
				case "FullTime":
				case "HalfTime":
					return <div className="CommentaryComment__separator--gray" />;
				default:
					return <div />;
			}
		};

		const getEvent = (comment) => {
			// not great but it means we can reuse Slide.js in the commentary
			return {
				"DisplayName": comment.EventDisplayName,
				"Id": comment.Id,
				"Player": comment.Player,
				"PlayerOn": comment.PlayerOn,
				"TimeStamp": comment.TimeStamp,
				"Comment": comment.Comment,
				"Minute": comment.Minute,
				"Outcome": comment.Outcome,
				"HighlightType": comment.HighlightType,
				"CardType": comment.CardType,
				"TeamName": comment.TeamName
			};
		}

		var showTime = this.props.comment.MatchMinute === "" && this.props.comment.DisplayMinutes === "0 mins" ;

		return (
				<div className="CommentaryComment">
				{getSeparator(this.props.comment)}

				{this.props.comment.IsHighlight
					? (
						<Slide event={getEvent(this.props.comment)} crestUrl={this.props.isHomeTeam ? this.props.homeTeamCrestUrl : this.props.awayTeamCrestUrl} />
					)
					: (
						<div className="CommentaryComment__wrapper">
							<div className="CommentaryComment__left">
								{showTime ?
									<div className="CommentaryComment__time">{this.createTime(this.props.comment.TimeStamp)}</div> :
									<div className="CommentaryComment__time">{this.props.comment.MatchMinute + " mins"}</div>
								}
							</div>

							<div className="CommentaryComment__right">
								{showTime && this.props.comment.DisplayMinutes === "0 mins" ?
									<div className="CommentaryComment__time">{this.createTime(this.props.comment.TimeStamp)}</div> :
									<div className="CommentaryComment__time">{this.props.comment.MatchMinute + " mins"}</div>
								}
								{this.props.comment.EventType !== "Default" && this.props.comment.EventType !== "Embedded" &&
									<div className="CommentaryComment__header">
										{getEventIcon(this.props.comment.EventType)}
										<span className="CommentaryComment__caption">{this.props.comment.DisplayName}</span>
									</div>
								}
								<div className="CommentaryComment__body" dangerouslySetInnerHTML={{ __html: this.decodeComment(this.props.comment.Comment) }} />
							</div>
						</div>
					)
				}

				{getSeparator(this.props.comment)}
			</div>
		)
	}
}

module.exports = CommentaryComment;



// WEBPACK FOOTER //
// ./src/components/MDC/Commentary/CommentaryComment.js